<template>
    <!-- https://www.svgrepo.com/svg/503994/chat-communication-conversation?edit=true -->
    <svg width="20px" height="20px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <title>folder_type_theme_opened</title>
        <path
            d="M27.4,5.5H18.2L16.1,9.7H4.3v4H.5L4.3,26.5H29.5V5.5ZM20.2,7.6h7.1V9.7H19.2Zm5.5,6.1H6.6V11.8H27.4v7.6Z"
            style="fill: #f09a0f"
        />
        <path
            d="M27.3,16.881A7.815,7.815,0,0,1,28.875,18.3a4.666,4.666,0,0,1,.17,6.087,5.186,5.186,0,0,1-3.162,1.765,9.328,9.328,0,0,1-3.381-.073,11,11,0,0,0-1.609-.176.9.9,0,0,0-1.046.724l0,.015a.944.944,0,0,0,.18.742,10.477,10.477,0,0,0,.848,1.108,2.175,2.175,0,0,1,.529.99.787.787,0,0,1-.491.946,6.371,6.371,0,0,1-3.139.552,14.984,14.984,0,0,1-7.736-2.555,6.838,6.838,0,0,1-2.928-4.416,5.869,5.869,0,0,1,1-4.544,10.176,10.176,0,0,1,4.318-3.6,15.053,15.053,0,0,1,11.67-.6C24.137,15.285,27.228,16.942,27.3,16.881Z"
            style="fill: #a86749"
        />
        <path
            d="M11.246,22.676a2.47,2.47,0,0,1,1.595.514,1.126,1.126,0,0,1,.32,1.533,1.088,1.088,0,0,1-.32.328,2.768,2.768,0,0,1-3.2,0,1.128,1.128,0,0,1-.329-1.535,1.086,1.086,0,0,1,.336-.342A2.458,2.458,0,0,1,11.246,22.676Z"
            style="fill: #3783ff"
        />
        <path
            d="M10.965,21.431a1.92,1.92,0,0,1-1.172-.371.9.9,0,0,1-.3-1.214.867.867,0,0,1,.29-.3,2.113,2.113,0,0,1,2.458.025.887.887,0,0,1,.235,1.212.864.864,0,0,1-.225.234A1.954,1.954,0,0,1,10.965,21.431Z"
            style="fill: #4de94c"
        />
        <path
            d="M14.109,18.49a1.462,1.462,0,0,1-1.072-.385.721.721,0,0,1-.087-1,.814.814,0,0,1,.087-.089,1.656,1.656,0,0,1,2.124,0,.721.721,0,0,1,.087,1,.678.678,0,0,1-.128.123A1.482,1.482,0,0,1,14.109,18.49Z"
            style="fill: #fe0"
        />
        <path
            d="M15.858,25.412a2.8,2.8,0,0,1,1.793.568,1.234,1.234,0,0,1,.373,1.677,1.2,1.2,0,0,1-.373.382,3.158,3.158,0,0,1-3.6,0,1.237,1.237,0,0,1-.39-1.678,1.214,1.214,0,0,1,.4-.4A2.8,2.8,0,0,1,15.858,25.412Z"
            style="fill: #4c1ac6"
        />
        <path
            d="M31,13.466a5.779,5.779,0,0,1-1.151,1.909A46.73,46.73,0,0,1,26.1,19.459a.512.512,0,0,1-.537.189.677.677,0,0,1-.251-.153q-.429-.409-.844-.833a.475.475,0,0,1-.076-.653.557.557,0,0,1,.052-.057A.664.664,0,0,1,24.5,17.9,48.492,48.492,0,0,1,28.6,14.2a8.543,8.543,0,0,1,1.421-.946,2.557,2.557,0,0,1,.507-.189.353.353,0,0,1,.463.187l0,.007v.007Z"
            style="fill: #2a3e4f"
        />
        <path
            d="M20,22.963a.08.08,0,0,1,.03.006A2.259,2.259,0,0,0,23,22.5a1.539,1.539,0,0,0,.412-1.21,1.173,1.173,0,0,0-1-1.006,1.025,1.025,0,0,0-.923.408,1.546,1.546,0,0,0-.284.657A2.574,2.574,0,0,1,20,22.938Z"
            style="fill: #7e8c8d"
        />
        <path
            d="M25.16,19.792c-.326-.327-.656-.651-.985-.976a.236.236,0,0,0-.33-.053l-.006,0a.252.252,0,0,0-.062.072q-.419.544-.831,1.092a.219.219,0,0,0,.008.3l.011.01q.369.366.739.728a.223.223,0,0,0,.313.029l0,0c.375-.277.751-.554,1.12-.839a.8.8,0,0,0,.136-.2A1.111,1.111,0,0,0,25.16,19.792Z"
            style="fill: #f89b36"
        />
        <path
            d="M17.864,17.121a1.145,1.145,0,0,1-.859-.321.617.617,0,0,1-.048-.856c.016-.018.032-.034.048-.05a1.286,1.286,0,0,1,1.7,0,.617.617,0,0,1,.048.857.583.583,0,0,1-.08.077A1.167,1.167,0,0,1,17.864,17.121Z"
            style="fill: #ff8c00"
        />
        <path
            d="M20,22.963s3.915-1.136,2.659-2.614c0,0-.857-.393-1.454,1.007A3.932,3.932,0,0,1,20,22.963Z"
            style="fill: #8f9fa0"
        />
        <path
            d="M23.305,20.585l1.374-1.272-.5-.5a.239.239,0,0,0-.335-.045l-.008.006a.221.221,0,0,0-.055.063c-.2.259-1.153,1.07-.813,1.407Z"
            style="fill: #e9bb42"
        />
        <path
            d="M24.877,19.073,31,13.254s.041-.393-.468-.2-.8-.177-6.093,4.9a.441.441,0,0,0,.024.71Z"
            style="fill: #32495d"
        />
        <path
            d="M21.721,17.41a1.152,1.152,0,0,1-.859-.321.617.617,0,0,1-.048-.857.555.555,0,0,1,.048-.049,1.286,1.286,0,0,1,1.7,0,.617.617,0,0,1,.048.855.549.549,0,0,1-.082.078A1.156,1.156,0,0,1,21.721,17.41Z"
            style="fill: #f60000"
        />
    </svg>
</template>

<script>
export default {
    name: "ThemeIcon",
};
</script>

<style scoped></style>
